import React, { useState } from "react";
import ProfitReport from "./ProfitReport";
import IncomeReport from "./IncomeReport";
import ExpenseReport from "./ExpenseReport";
import DailyReport from "./DailyReport";

const Reports = () => {
  const [activeReport, setActiveReport] = useState(null);

  const renderReport = () => {
    switch (activeReport) {
      case "profit":
        return <ProfitReport />;
      case "income":
        return <IncomeReport />;
      case "expense":
        return <ExpenseReport />;
      case "daily":
        return <DailyReport />;
      default:
        return null;
    }
  };

  const reportCards = [
    { id: "profit", title: "Profit" },
    { id: "income", title: "Income" },
    { id: "expense", title: "Expense" },
    { id: "daily", title: "Daily Report" },
  ];

  return (
    <div>
      {/* Header */}
      <div className="bg-white px-6 py-5 border-b">
        <div className="text-lg text-gray-500">
          <h1>Reports</h1>
        </div>
      </div>

      {/* Report Cards */}
      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 bg-gray-50 px-6 py-4">
        {reportCards.map((report) => (
          <div key={report.id} className="max-w-7xl">
            <div
              className={`relative group shadow-md rounded-lg ${
                activeReport === report.id ? "bg-gray-600 text-white border border-gray-500" : "bg-white text-black"
              }`}
            >
              <div
                className="relative px-7 py-6 ring-1 ring-gray-900/5 text-black rounded-lg leading-none flex items-top justify-start space-x-6 cursor-pointer"
                onClick={() => setActiveReport(report.id)}
              >
                <div className="space-y-2">
                <p className={`text-xl ${activeReport === report.id ? "text-white" : "text-black"}`}>{report.title}</p>


                  <a
                    className={`block ${
                      activeReport === report.id
                        ? "text-white font-semibold"
                        : "text-indigo-400 group-hover:text-slate-800"
                    } transition duration-200`}
                  >
                    Show Report →
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Render Report */}
      <div className="mt-10">{renderReport()}</div>
    </div>
  );
};

export default Reports;
